import { useTranslation } from 'react-i18next';
import { FilterOption, GenericValueLabel } from '../../../types';

export const useExceptionLogsFilters = (): FilterOption[] => {
  const { t } = useTranslation('traffic_monitor');
  const exceptionLogTypes = [
    {
      value: 'ConsultationException',
      label: t('IncomingConsultation', 'Incoming Consultation'),
    },
    {
      value: 'ResponseException',
      label: t('IncomingResponse', 'Incoming Response'),
    },
    {
      value: 'ExtensionException',
      label: t('IncomingExtension', 'Incoming Extension'),
    },
    {
      value: 'DocumentException',
      label: t('IncomingDocument', 'Incoming Document'),
    },
  ];

  return [
    createFilterOptionItemWithDefaultValues(
      'keyword',
      t('keyword', 'Search for planning applications'),
      undefined,
      false,
      true
    ),
    createFilterOptionItemWithDefaultValues(
      'exceptionLogType',
      t('exception_type', 'Exception Type'),
      [...exceptionLogTypes],
      false,
      false,
      [{ value: 'ConsultationException', label: 'Incoming Consultation' }]
    ),
  ];
};

export const createFilterOptionItemWithDefaultValues = (
  name: string,
  header: string,
  items: GenericValueLabel[] | undefined,
  allowMultiSelect?: boolean | null,
  isSearchText?: boolean | null,
  selectedItems?: GenericValueLabel[] | undefined
): FilterOption => {
  return {
    name,
    header,
    items: items ?? [],
    selectedItems: selectedItems ?? [],
    allowMultiSelect: allowMultiSelect ?? true,
    isSearchText: isSearchText ?? false,
  };
};
